// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { s_pig_default } from "../../code/AssetDefinitions/ImageDefinitions";
import { tbBrowser } from "../../engine/tbBrowser";
import { tbImageFromImage } from "../tbImageFromImage";
import { tgfGraphics } from "../tgfGraphics";
import { tgfSettings } from "../tgfSettings";
import { tgfHooks } from "./hooks";
export var FBInstant = window["FBInstant"];
export var FBInstantAPI = function () {
    "use strict";
    this.playerID = "test";
    this.device = "";
    this.locale = "";
    this.playerName = "";
    this.playerImage = "";
    this.otherPlayerIDs = null;
    this.otherPlayerIDsCallbacks = [];
    this.globalKey = ["mainFW", "extra", "saveState"];
    this.deviceSpecs = {
        os: "",
        os_major: "",
        device: ""
    };
    this.initialized = false;
    this.extraData = undefined;
    this.richGameplayFeatures = undefined;
    this._adInstance = null;
    this._adIsLoaded = false;
    this._playingAd = false;
};
FBInstantAPI.POST = "POST";
FBInstantAPI.THREAD = "THREAD";
FBInstantAPI.GROUP = "GROUP";
FBInstantAPI.MATCH = "MATCH";
FBInstantAPI.SOLO = "SOLO";
FBInstantAPI.SHARE = "SHARE";
FBInstantAPI.INVITE = "INVITE";
FBInstantAPI.REQUEST = "REQUEST";
FBInstantAPI.CHALLENGE = "CHALLENGE";
FBInstantAPI.IMMEDIATE = "IMMEDIATE";
FBInstantAPI.IMMEDIATE_CLEAR = "IMMEDIATE_CLEAR";
FBInstantAPI.LAST = "LAST";
FBInstantAPI.PUSH = "PUSH";
FBInstantAPI.NO_PUSH = "NO_PUSH";
FBInstantAPI._defaultImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
FBInstantAPI.prototype._doNothing = function () { };
FBInstantAPI.prototype._warnUser = function (message) {
    console.log("Error from Facebook SDK 4.1: " + message);
};
FBInstantAPI.prototype.loadFriendsIDs = function (call, onFail) {
    var dataPromise = FBInstant["player"]["getConnectedPlayersAsync"]();
    var self = this;
    var callback = call ? call : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    var resolve = dataPromise.then(function (players) {
        //self.setOtherPlayerIDs(players);
        callback(players);
    });
    resolve["catch"](fail);
};
FBInstantAPI.prototype.init = function (call, onFail) {
    "use strict";
    var self = this;
    var callback = call ? call : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    try {
        var dataPromise = FBInstant["initializeAsync"]();
        var resolve = dataPromise.then(function () {
            console.log('FBI::init.resolve');
            self.initialized = true;
            self.setDevice(FBInstant["getPlatform"]());
            self.setPlayerID(FBInstant["player"]["getID"]());
            tgfProfile.userId = self.playerID;
            tgfAnalytics.initialize(tgfSettings.analytics);
            tgfAnalytics.externalDeviceInfo = self.deviceSpecs;
            tgfAnalytics.startSession();
            var contextId = FBInstant["context"]["getID"]();
            var contextType = FBInstant["context"]["getType"]();
            tgfAnalytics.reportEventExt("context_", contextType, contextId === null ? 0 : parseFloat(contextId), "design");
            callback();
        });
        resolve["catch"](fail);
    }
    catch (e) {
        this._warnUser("init failed");
        callback();
    }
    //TG.analytics.start([TG.config.ga.gameKey, TG.config.ga.secretKey]);
};
FBInstantAPI.prototype.setProgress = function (prog) {
    "use strict";
    try {
        //FBInstant["loading"]["setProgress"](prog);
        FBInstant["setLoadingProgress"](prog);
    }
    catch (e) {
        this._warnUser("set progress failed");
    }
};
FBInstantAPI.prototype.saveData = function (key, data, onSuccess, onFail) {
    "use strict";
    var sendData;
    var success = onSuccess ? onSuccess : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    //if(data === typeof String){
    //  sendData = data;
    //} else {
    //  sendData = JSON.stringify(data);
    //}
    var _data = { "mainFW": data };
    var dataPromise = FBInstant["player"]["setDataAsync"](_data);
    var resolve = dataPromise.then(success);
    resolve["catch"](fail);
};
FBInstantAPI.prototype.extraSaveData = function (data, onSuccess, onFail) {
    "use strict";
    var sendData;
    var success = onSuccess ? onSuccess : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    if (data === typeof String) {
        sendData = data;
    }
    else {
        sendData = JSON.stringify(data);
    }
    var _data = { "saveState": sendData };
    var dataPromise = FBInstant["player"]["setDataAsync"](_data);
    var resolve = dataPromise.then(success);
    resolve["catch"](fail);
};
FBInstantAPI.prototype.gdprSaveData = function (data, onSuccess, onFail) {
    "use strict";
    var sendData;
    var success = onSuccess ? onSuccess : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    if (data === typeof String) {
        sendData = data;
    }
    else {
        sendData = JSON.stringify(data);
    }
    var _data = { "gdpr": sendData };
    var dataPromise = FBInstant["player"]["setDataAsync"](_data);
    var resolve = dataPromise.then(success);
    resolve["catch"](fail);
};
FBInstantAPI.prototype.gdprLoadData = function (onSuccess, onFail) {
    "use strict";
    var self = this;
    var fail = onFail ? onFail : this._doNothing;
    var success = onSuccess ? onSuccess : this._doNothing;
    try {
        var dataPromise = FBInstant["player"]["getDataAsync"](["gdpr"]);
        var resolve = dataPromise.then(function (data) {
            onSuccess(data["gdpr"]);
        }).catch(function (e) {
            console.log(e);
        });
    }
    catch (e) {
        this._warnUser("load data failed");
        onFail(e);
    }
};
FBInstantAPI.prototype.loadData = function (key, call, onSuccess, onFail) {
    "use strict";
    var self = this;
    var callback = call ? call : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    var success = onSuccess ? onSuccess : this._doNothing;
    try {
        var dataPromise = FBInstant["player"]["getDataAsync"](this.globalKey);
        var resolve = dataPromise.then(function (data) {
            if (callback && data) {
                //up until FB SDK version 2.1, save games were stored without using a timestamp.
                //to remain compatible with these savefiles, check whether the data is stored directly as a JSON object. 
                //If it is, create a wrapper that holds the timeStamp as well as the data.
                if (data["saveState"]) {
                    var wrapper = JSON.parse(data["saveState"]);
                    //if there already a file stored in FB that contains the new format, we return it as is.
                    var obj = JSON.parse(wrapper);
                    self.extraData = JSON.parse(obj['data']);
                    callback(wrapper);
                }
                else if (data["extra"]) {
                    //otherwise, let's see if this is an old user, that still saved the data in the old way.
                    self.extraData = JSON.parse(data["extra"]);
                    var wrapper = JSON.stringify({
                        timeStamp: new Date().getTime(),
                        data: data["extra"]
                    });
                    callback(wrapper);
                }
                success();
            }
        });
        resolve["catch"](fail);
    }
    catch (e) {
        this._warnUser("load data failed");
    }
};
FBInstantAPI.prototype.getSupportedAPIs = function () {
    "use strict";
    try {
        return FBInstant["getSupportedAPIs"]();
    }
    catch (e) {
        this._warnUser("getting supported API functions failed.");
    }
};
FBInstantAPI.prototype.getEntryPointData = function () {
    "use strict";
    try {
        return FBInstant["getEntryPointData"]();
    }
    catch (e) {
        this._warnUser("retrieving entry point data failed");
    }
};
FBInstantAPI.prototype.getEntryPointAsync = function () {
    "use strict";
    try {
        return FBInstant["getEntryPointAsync"]();
    }
    catch (e) {
        this._warnUser("retrieving entry point async failed");
    }
};
FBInstantAPI.prototype.setSessionData = function (data) {
    "use strict";
    try {
        var string = JSON.stringify(data);
        if (string.length > 999) {
            this._warnUser("too much data in set session data");
            return;
        }
        return FBInstant["setSessionData"](data);
    }
    catch (e) {
        this._warnUser("setting session data failed");
    }
};
FBInstantAPI.prototype.loadingCompleted = function () {
    "use strict";
    var self = this;
    try {
        var promise = FBInstant["startGameAsync"]();
        var resolve = promise.then(function () {
            console.log('FBI::startGameAsync.resolve');
            self.richGameplayFeatures = true;
            self.setLocale(FBInstant["getLocale"]());
            self.setPlayerName(FBInstant["player"]["getName"]());
            self.setPlayerImage(FBInstant["player"]["getPhoto"](), function () {
                if (tgfHooks.getStartCallback) {
                    var call = tgfHooks.getStartCallback();
                    if (call)
                        call();
                }
            });
        });
        resolve["catch"](function () {
            self.richGameplayFeatures = false;
        });
    }
    catch (e) {
        this._warnUser("load complete failed");
        //TG.hooks.startInGame();
    }
};
FBInstantAPI.prototype.setScore = function (score) {
    "use strict";
    try {
        FBInstant["setScore"](score);
    }
    catch (e) {
        this._warnUser("setting score through the Facebook API is no longer supported!");
    }
};
FBInstantAPI.prototype.quit = function (call) {
    "use strict";
    var callback = call ? call : this._doNothing;
    try {
        callback();
        FBInstant["quit"]();
    }
    catch (e) {
        this._warnUser("couldn't quit");
    }
};
FBInstantAPI.prototype.logEvent = function (event, sum, params) {
    "use strict";
    var _event = event ? event : "noEvent", _sum = (sum !== undefined) ? sum : 0, _params = (params !== undefined) ? params : {};
    try {
        FBInstant["logEvent"](_event, _sum, _params);
    }
    catch (e) {
        this._warnUser("couldn't send event " + e);
    }
};
FBInstantAPI.prototype.onPause = function (call) {
    "use strict";
    var callback = call ? call : this._doNothing;
    try {
        FBInstant["onPause"](call);
    }
    catch (e) {
        this._warnUser("pausing failed:" + e);
    }
};
/*

action string For custom updates, this should be 'CUSTOM'.
template string ID of the template this custom update is using. Templates should be predefined in fbapp-config.json. See the [Bundle Config documentation]https://developers.facebook.com/docs/games/instant-games/bundle-config for documentation about fbapp-config.json.
cta string? Optional call-to-action button text. By default we will use a localized 'Play' as the button text.
image string Data URL of a base64 encoded image.
text string A text message.
data Object? A blob of data to attach to the update. All game sessions launched from the update will be able to access this blob through FBInstant.getEntryPointData(). Must be less than or equal to 1000 characters when stringified.
strategy string? Specifies how the update should be delivered. This can be one of the following: 'IMMEDIATE' - The update should be posted immediately. 'LAST' - The update should be posted when the game session ends. The most recent update sent using the 'LAST' strategy will be the one sent. 'IMMEDIATE_CLEAR' - The update is posted immediately, and clears any other pending updates (such as those sent with the 'LAST' strategy). If no strategy is specified, we default to 'IMMEDIATE'.
notification string? Specifies notification setting for the custom update. This can be 'NO_PUSH' or 'PUSH', and defaults to 'NO_PUSH'. Use push notification only for updates that are high-signal and immediately actionable for the recipients. Also note that push notification is not always guaranteed, depending on user setting and platform policies.

*/
FBInstantAPI.prototype.updateAsync = function (call, template, image, buttonText, message, data, onFail, strategy, notification) {
    "use strict";
    var callback = call ? call : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    var self = this;
    var payload = {
        "action": "CUSTOM",
        "template": template,
        "image": image ? image : FBInstantAPI._defaultImage,
        "cta": buttonText ? buttonText : "",
        "text": message ? message : "",
        "data": data ? data : {},
        "strategy": strategy ? strategy : "IMMEDIATE_CLEAR",
        "notification": notification ? notification : "PUSH"
    };
    if (JSON.stringify(payload['data']).length > 999) {
        this._warnUser("too much data in update async");
        return;
    }
    try {
        var dataPromise = FBInstant["updateAsync"](payload);
        var resolve = dataPromise.then(function () {
            callback();
        });
        resolve["catch"](fail);
    }
    catch (e) {
        callback();
        this._warnUser("async update failed");
    }
};
FBInstantAPI.prototype.createContext = function (call, playerId, onFail) {
    "use strict";
    var callback = call ? call : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    var self = this;
    try {
        var dataPromise = FBInstant["context"]["createAsync"](playerId);
        var resolve = dataPromise.then(function () {
            callback();
        });
        resolve["catch"](fail);
    }
    catch (e) {
        this._warnUser("Exception on switch context: " + e);
        fail();
    }
};
FBInstantAPI.prototype.switchContext = function (context, call, onFail) {
    "use strict";
    var callback = call ? call : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    var self = this;
    try {
        var dataPromise = FBInstant["context"]["switchAsync"](context);
        var resolve = dataPromise.then(function () {
            callback();
        });
        resolve["catch"](fail);
    }
    catch (e) {
        callback();
        this._warnUser("switch context failed");
    }
};
FBInstantAPI.prototype.chooseContext = function (call, onFail, options) {
    var callback = call ? call : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    var self = this;
    var options = options || { filters: ["NEW_CONTEXT_ONLY"], maxSize: 2 };
    var dataPromise = FBInstant["context"]["chooseAsync"](options);
    dataPromise.then(function () {
        callback();
    }, function (reason) {
        console.log('chooseContext.failed', reason);
        console.log('   reason.code', reason.code);
        console.log('   reason.message', reason.message);
        fail(reason);
        this._warnUser("choose context failed");
    });
};
FBInstantAPI.prototype.share = function (call, shareType, image, message, data, onFail) {
    "use strict";
    var callback = call ? call : this._doNothing;
    var fail = onFail ? onFail : this._doNothing;
    var payload = {
        "intent": shareType ? shareType : "SHARE",
        "image": image ? image : FBInstantAPI._defaultImage,
        "text": message ? message : "",
        "data": data ? data : {}
    };
    if (JSON.stringify(payload['data']).length > 999) {
        this._warnUser("too much data in update async");
        return;
    }
    try {
        var dataPromise = FBInstant["shareAsync"](payload);
        var resolve = dataPromise.then(callback);
        resolve["catch"](fail);
    }
    catch (e) {
        callback();
        this._warnUser("share failed");
    }
};
// Needs to be somewhere relevant, probably inserted after PIXI render calls
FBInstantAPI.prototype.getScreenShot = function (index) {
    var canvasses = tgfGraphics.getAllCanvasses();
    return canvasses[index].toDataURL();
};
// Legacy, use .share() method instead
FBInstantAPI.prototype.screenShot = function (call) {
    this.share(call);
};
// Legacy, use .share() method instead
FBInstantAPI.prototype.otherScreenShot = function (call, index) {
    this.share(call, FBInstantAPI.SHARE, this.getScreenShot(index ? index : 0));
};
FBInstantAPI.prototype.setOtherPlayerIDs = function (otherPlayerIDs) {
    "use strict";
    this.otherPlayerIDs = otherPlayerIDs;
    for (var i = 0; i < this.otherPlayerIDsCallbacks.length; ++i) {
        this.otherPlayerIDsCallbacks[i](this.otherPlayerIDs);
    }
};
FBInstantAPI.prototype.getOtherPlayerIDs = function (callback) {
    "use strict";
    if (callback) {
        if (this.otherPlayerIDs !== null) {
            callback(this.otherPlayerIDs);
        }
        else {
            this.otherPlayerIDsCallbacks.push(callback);
        }
    }
    else {
        throw new Error('specify a callback. Getting player IDs is an asynchronous event!');
    }
};
FBInstantAPI.prototype.getPlayerInfo = function (callback, payload) {
    "use strict";
    FBInstant["player"]["getSignedPlayerInfoAsync"](payload)
        .then(function (result) {
        callback(result);
    });
};
FBInstantAPI.prototype.getContextPlayers = function (callback, onFail) {
    "use strict";
    var fail = onFail ? onFail : this._doNothing;
    FBInstant["context"]["getPlayersAsync"]()
        .then(function (result) {
        callback(result);
    })
        .catch(fail);
};
FBInstantAPI.prototype.isSizeBetween = function (min, max) {
    "use strict";
    var result = FBInstant["context"]["isSizeBetween"](min, max);
    var answer = false;
    if (result) {
        answer = result["answer"];
    }
    return answer;
};
FBInstantAPI.prototype.setPlayerID = function (id) {
    "use strict";
    this.playerID = id;
};
FBInstantAPI.prototype.getPlayerID = function () {
    "use strict";
    return this.playerID;
};
FBInstantAPI.prototype.getContextID = function () {
    "use strict";
    return FBInstant["context"]["getID"]();
};
FBInstantAPI.prototype.getContextType = function () {
    "use strict";
    return FBInstant["context"]["getType"]();
};
FBInstantAPI.prototype.setLocale = function (locale) {
    "use strict";
    if (!locale) {
        locale = "";
    }
    this.locale = locale;
};
FBInstantAPI.prototype.getLocale = function () {
    "use strict";
    return this.locale;
};
FBInstantAPI.prototype.setPlayerName = function (name) {
    "use strict";
    this.playerName = name;
};
FBInstantAPI.prototype.getPlayerName = function () {
    "use strict";
    return this.playerName;
};
FBInstantAPI.prototype.createImageFromURL = function (url, onLoaded) {
    'use strict';
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = url;
    if (img.addEventListener) {
        img.addEventListener('error', function (e) {
            e.preventDefault(); // Prevent error from getting thrown
            onLoaded(s_pig_default);
        });
    }
    else {
        // Old IE uses .attachEvent instead
        img.attachEvent('onerror', function (e) {
            onLoaded(s_pig_default);
            return false; // Prevent propagation
        });
    }
    img.onload = function () {
        var tbImg = tbImageFromImage(url, img, img["width"], img["height"], 0, 0);
        if (onLoaded) {
            onLoaded(tbImg);
        }
    };
};
FBInstantAPI.prototype.setPlayerImage = function (image, callback) {
    "use strict";
    var self = this;
    var playerImage = new Image();
    playerImage.crossOrigin = 'anonymous';
    playerImage.src = image;
    this.setPlayerImageURL(image);
    playerImage.onload = function () {
        self.playerImage = tbImageFromImage("playerImage", playerImage, playerImage["width"], playerImage["height"], 0, 0);
        if (callback)
            callback();
        //console.log("Image created");
    };
    playerImage.onerror = function () {
        self.playerImage = null;
        if (callback)
            callback();
    };
};
FBInstantAPI.prototype.getPlayerImage = function () {
    "use strict";
    return this.playerImage;
};
FBInstantAPI.prototype.setPlayerImageURL = function (url) {
    'use strict';
    this.playerImageURL = url;
};
FBInstantAPI.prototype.getPlayerImageURL = function () {
    'use strict';
    return this.playerImageURL;
};
FBInstantAPI.prototype.setDevice = function (device) {
    "use strict";
    switch (device) {
        case "WEB":
            this.deviceSpecs.device = "webplayer";
            break;
        case "IOS":
            this.deviceSpecs.device = "ios";
            break;
        case "ANDROID":
            this.deviceSpecs.device = "android";
            break;
        case "MOBILE_WEB":
            this.deviceSpecs.device = "mobileweb";
            break;
        default:
            this.deviceSpecs.device = "unknown";
    }
    if (tbBrowser.os.version !== '' && tbBrowser.os.version) {
        this.deviceSpecs.os_major = this.deviceSpecs.os + " " + tbBrowser.os.version;
    }
    else {
        this.deviceSpecs.os_major = this.deviceSpecs.os + " 0.0";
    }
    //this.deviceSpecs.device = tbBrowser.name;
};
FBInstantAPI.prototype.getDevice = function () {
    "use strict";
    return {
        device: this.deviceSpecs.device,
        os: this.deviceSpecs.os,
        os_major: this.deviceSpecs.os_major
    };
};
FBInstantAPI.prototype.isInitialized = function () {
    "use strict";
    return this.initialized;
};
FBInstantAPI.prototype.playAd = function (context, afterAdCallback, placementID) {
    var self = this;
    if (self._adInstance && self._adIsLoaded) {
        self._playingAd = true;
        self._playAdInstance = null;
        self._adInstance["showAsync"]()["then"](function () {
            self._adInstance = null;
            self._adIsLoaded = false;
            self._playingAd = false;
            afterAdCallback(true, context, "success");
        }, function (err) {
            self._adInstance = null;
            self._adIsLoaded = false;
            self._playingAd = false;
            afterAdCallback(false, context, "facebook error:\n" + err.message);
            console.warn(err);
        });
    }
    else {
        // afterAdCallback(false, context, "no ad instance");
        self._playAdInstance = {
            context: context,
            afterAdCallback: afterAdCallback,
            placementID: placementID
        };
        if (self._adInstance) {
            self._loadAdInstance(self._adInstance);
        }
        else {
            self.prepareAd(placementID);
        }
    }
};
FBInstantAPI.prototype.prepareAd = function (placementID) {
    if (!this.areAdsSupported()) {
        console.warn("Ads aren't supported");
        return;
    }
    var self = this;
    if (!self._adInstance) {
        this._getRewardedVideo(placementID);
    }
};
FBInstantAPI.prototype._getRewardedVideo = function (placementID) {
    var self = this;
    FBInstant["getRewardedVideoAsync"](placementID)["then"](function (adInstance) {
        self._adInstance = adInstance;
        self._loadAdInstance(adInstance);
    }, function (err) {
        //self._msngrLog("getRewardedVideo: " + err.message + " " + placementID);
        console.warn(err);
        // restart on 1 min delay
        setTimeout(function () {
            self._getRewardedVideo();
        }, 60000);
    }, this);
};
FBInstantAPI.prototype._msngrLog = function (message) {
    var fbDebug = document.createElement("div");
    fbDebug.added = false;
    fbDebug.style.position = "absolute";
    fbDebug.style.zIndex = 10000000;
    fbDebug.style.font = "9px monospace";
    fbDebug.style.background = "rgba(0, 0, 0, 1)";
    fbDebug.style.top = this._extraTopMargin + "px";
    fbDebug.style.color = "rgba(255, 255, 255, 1)";
    fbDebug.style.padding = "0";
    fbDebug.style.margin = "0";
    fbDebug.style.whiteSpace = "pre";
    fbDebug.style.borderRadius = "2px";
    fbDebug.style.width = "100%";
    var t = document.createTextNode(message);
    fbDebug.appendChild(t);
    document.body.appendChild(fbDebug);
};
FBInstantAPI.prototype._loadAdInstance = function (adInstance) {
    var self = this;
    adInstance["loadAsync"]()["then"](function () {
        self._adIsLoaded = true;
        if (self._playAdInstance) {
            self.playAd(self._playAdInstance.context, self._playAdInstance.afterAdCallback, self._playAdInstance.placementID);
        }
    }, function (err) {
        //self._msngrLog("getRewardedVideo: " + err.message);
        console.warn(err);
        // restart on a 1 min delay
        setTimeout(function () {
            self._loadAdInstance(adInstance);
        }, 60000);
    });
};
FBInstantAPI.prototype.areAdsSupported = function () {
    var fbSupportedApis = [];
    if (Array.from) {
        fbSupportedApis = this.getSupportedAPIs();
    }
    var rewardedAdsSupported = false;
    fbSupportedApis.forEach(function (supportedApiString) {
        if (supportedApiString == 'getRewardedVideoAsync') {
            rewardedAdsSupported = true;
        }
    }, this);
    var adsSupported = rewardedAdsSupported;
    return adsSupported;
};
FBInstantAPI.prototype.isPlayingAd = function () {
    return this._playingAd;
};
FBInstantAPI.prototype.createHomeScreenButton = function () {
    return FBInstant.canCreateShortcutAsync()
        .then(function (canCreateShortcut) {
        if (canCreateShortcut) {
            return FBInstant.createShortcutAsync();
        }
        else {
            throw new Error("Shortcut creation not allowed");
        }
    });
};
FBInstantAPI.prototype.canCreateShortcutAsync = function () {
    return FBInstant.canCreateShortcutAsync();
};
export var fbInstant = new FBInstantAPI();
